import { render, staticRenderFns } from "./TradeContractTable.vue?vue&type=template&id=59e0ff53&"
import script from "./TradeContractTable.vue?vue&type=script&lang=js&"
export * from "./TradeContractTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports